class popupMessageSystem {

    constructor() {
        this.init();
    }

    init() {
        if ($('a[data-messageid]').length > 0) {

            this.initMessagehandlers();

            $.get('/index.php/infoszovegek/getinaktivids', { r: new Date().getTime() }, function (res) {
                if (res.ids.length > 0) {
                    $.each(res.ids, function (i, id) {
                        $('a[data-messageid]').each(function (i, el) {
                            if ($(el).data('messageid') == id) {
                                $(el).addClass('hide');
                            }
                        })
                    })
                }
            }, 'json')
        }
    }

    initMessagehandlers() {
        $('a[data-messageid]').each((i, el) => {
            $(el).on("click", (e) => {
                e.preventDefault();
                this.openMessage(e.target);
            })
        });
    }

    openMessage(el) {
        var messageId = $(el).data('messageid');

        if (messageId > 0) {

            $.get('/index.php/infoszovegek/getbyid', { id: messageId, r: new Date().getTime() }, (res) => {
                if (res.szoveg != '') {
                    this.showWin(res.szoveg)
                }
            }, 'json')
        }

    }

    showWin(pMessage, extraclass, closeRemoveClass, closeDuration) {
        if (!extraclass) extraclass = "";
        if (!closeRemoveClass) closeRemoveClass = "";
        if (!closeDuration) closeDuration = 0;

        $('.pms-overlay, .pms-main-win').remove();
        $('body').removeClass('pms-showing');
        var msgwin = $('<div>').addClass('pms-main-win');
        msgwin.addClass(extraclass)

        $('<div>').addClass('pms-overlay').on("click",
            function (e) {
                e.preventDefault();
                $('.pms-main-win').removeClass(closeRemoveClass);
                setTimeout(function () {
                    $('.pms-overlay, .pms-main-win').remove();
                    $('body').removeClass('pms-showing');
                }, closeDuration);
            }).appendTo($('body')
            );
        $('<a>').addClass('closeme').attr("href", "").on("click", function (e) {
            e.preventDefault();
            $('.pms-main-win').removeClass(closeRemoveClass);
            setTimeout(function () {
                $('.pms-overlay, .pms-main-win').remove();
                $('body').removeClass('pms-showing');
            }, closeDuration);
        }).appendTo(msgwin);
        $('<div>').addClass('pms-message').html(pMessage).appendTo(msgwin);
        msgwin.appendTo($('body'));
        $('body').addClass('pms-showing');
    }
}

export default popupMessageSystem;



